import React from "react";

function ProductDetails() {
  return <div>Information about one product</div>;
}

export default ProductDetails;
